export const handleImageUrl = (url) => {
    if (!url) return '';
    if (/^https?:\/\//i.test(url)) return url;
    const base = (process.env.REACT_APP_LOCAL_API || '/').replace(/\/$/, '');
    const prefix = (process.env.REACT_APP_UPLOADS_PATH_PREFIX ?? 'public').replace(/^\/+|\/+$/g, '');
    const path = String(url).replace(/^\//, '');
    return prefix ? `${base}/${prefix}/${path}` : `${base}/${path}`;
}